export default "__VITE_ASSET__MY$kfpfs__"